import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UserService } from '../../service/data/user.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { StandardCommandHandlerResolver } from '../../../core/service/command/standard-command-handler-resolver.service';
import { User } from '../../model/user';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';

@Component({
    selector: 'app-user-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserManagerComponent extends PagedObjectManagerComponent<User> {
  constructor(
    webUserService: UserService,
    dispatcher: CommandDispatcher,
    handlerResolver: StandardCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService,
    columnDefinitionFactory: ColumnDefinitionFactory
  ) {
    super(webUserService, messageService, navigationService, dispatcher, handlerResolver);

    this.columnDefinition = [
      columnDefinitionFactory.create('USER.NAME', 'name'),
      columnDefinitionFactory.create('TENANT.NAME', 'personName'),
      columnDefinitionFactory.createDateTime('USER.LAST_LOGIN', 'lastLogin'),
    ];
    this.title = 'USER.LIST_HEADER';
  }

  ngOnInit() {
    this.AddSubscription(
      (<UserService>this.dataService).getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.filter.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem('TENANT.NAME', 'name', definition.filter.name, null, definition.filter.selectedFields.includes('name')),
          new FilterDefinitionItem('USER.NAME', 'email', definition.filter.email, null, definition.filter.selectedFields.includes('email')),
        ];
      })
    );

    this.addEditDeleteCommands();
  }
}
